angular.module('am4').controller('mapsCtrl', function($scope, $rootScope, $state, $stateParams, mapsService, errorService) {
    var that = this,
        watcher = $rootScope.$on('maps:update', function() {
            mapsService.getAll($state.params.id)
            .then(function(m) {
                that.maps = m;
            });
        });

    that.loading = true;

    mapsService.getAll($stateParams.id).then(function(maps) {
        that.maps = maps;
    })
    .catch(function(e) {
        errorService.addError('GET_MAPS_ERROR', e);
    })
    .finally(function() {
        that.loading = false;
    });

    $scope.$on('$destroy', function() {
        watcher(); // cleanup
    });
});



// WEBPACK FOOTER //
// ./src/app/controllers/mapsCtrl.js